/**
 * Alluvion Home — Default product template: Frame Swatches
 * ========================================================
 * Separate copy for normal prints on the default product template, so the
 * Print Your Own, address print and drinks print pickers stay untouched.
 * Loaded from theme.liquid only on the default product template.
 *
 * Safety: it only takes over if EVERY value of the product's "Style" option
 * is one of the five frames below. Any other product (e.g. canvases with
 * different options) keeps Dawn's normal dropdown. Frames a product doesn't
 * offer are simply not shown.
 *
 * Shows 5 frame swatches and an "Add a mount" switch instead of Dawn's
 * 10-value Framing dropdown. Your variants stay exactly as they are:
 * this script picks the matching value (e.g. "Black Frame With Mount")
 * in Dawn's own Framing control, which it hides. Dawn then updates the
 * price, variant and URL as normal, and the live preview follows.
 *
 * No metafields or theme version changes needed. Works whether Dawn's
 * variant picker is set to Dropdown or Pills.
 *
 * SWATCH IMAGES (optional)
 *   Upload small square images (e.g. 200×200 corner crops) to
 *   Content → Files, then add this to layout/theme.liquid just above
 *   the Alluvion script tags:
 *
 *   <script>
 *     window.ALV_SWATCHES = {
 *       'Print Only':      {{ 'swatch-print-only.jpg' | file_url | json }},
 *       'Black Frame':     {{ 'swatch-black.jpg' | file_url | json }},
 *       'White Frame':     {{ 'swatch-white.jpg' | file_url | json }},
 *       'Light Oak Frame': {{ 'swatch-light-oak.jpg' | file_url | json }},
 *       'Dark Oak Frame':  {{ 'swatch-dark-oak.jpg' | file_url | json }}
 *     };
 *   </script>
 *
 *   Without them, plain colour chips are shown.
 */

(function () {
  'use strict';

  var CFG = {
    option: 'Style',   /* Dawn option that holds the frame choice */
    mount:  false,
    label:  'Frame'    /* heading shown above the swatches */
  };

  var OPTION       = CFG.option;
  var MOUNT_SUFFIX = ' With Mount';

  var FRAMES = [
    { value: 'Print Only',      label: 'Print only', color: '#ffffff' },
    { value: 'Black Frame',     label: 'Black',      color: '#1c1c1c' },
    { value: 'White Frame',     label: 'White',      color: '#f4f3ef' },
    { value: 'Light Oak Frame', label: 'Light oak',  color: '#cfa874' },
    { value: 'Dark Oak Frame',  label: 'Dark oak',   color: '#5e3d27' }
  ];

  /* Line shown under "Add a mount" — edit the wording here */
  var MOUNT_TEXT = 'A professional gallery-style white mount';


  var state = { frame: 'Print Only', mount: false };
  var ui = {};
  var productData = null;

  function init() {
    var current = getDawnValue();
    if (!current) {
      console.warn('[Alluvion Frames] Framing option not found — leaving Dawn\'s picker visible');
      return;
    }
    var values = dawnValues();
    var known = FRAMES.map(function (f) { return f.value; });
    if (!values.length || values.some(function (v) { return known.indexOf(v) === -1; })) {
      return;   /* not a standard frame option — leave Dawn's picker as it is */
    }
    FRAMES = FRAMES.filter(function (f) { return values.indexOf(f.value) !== -1; });
    parseValue(current);
    productData = readProductJson();
    injectStyles();
    buildUi();
    hideDawnControl();
    watchDawn();
    document.addEventListener('change', onAnyChange);
    update();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* ── Prices (from the product JSON tag) ─────────────────────────── */
  function readProductJson() {
    var el = document.getElementById('alv-product-json');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  function optionIndex(name) {
    if (!productData || !productData.options) return -1;
    for (var i = 0; i < productData.options.length; i++) {
      var o = productData.options[i];
      if ((typeof o === 'object' ? o.name : o).indexOf(name) !== -1) return i;
    }
    return -1;
  }

  /* Price in pence of a Framing value at the currently selected size */
  function priceFor(framingValue) {
    if (!productData || !productData.variants) return null;
    var frameIdx = optionIndex(OPTION);
    var sizeIdx  = optionIndex('Size');
    if (frameIdx < 0) return null;
    var sizeVal = sizeIdx >= 0 ? getOptionValue('Size') : null;
    var match = productData.variants.find(function (v) {
      return v['option' + (frameIdx + 1)] === framingValue &&
        (sizeIdx < 0 || v['option' + (sizeIdx + 1)] === sizeVal);
    });
    return match ? match.price : null;
  }

  function formatMoney(pence) {
    var currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'GBP';
    var whole = pence % 100 === 0;
    try {
      return new Intl.NumberFormat('en-GB', {
        style: 'currency',
        currency: currency,
        minimumFractionDigits: whole ? 0 : 2,
        maximumFractionDigits: whole ? 0 : 2
      }).format(pence / 100);
    } catch (e) {
      return '£' + (pence / 100).toFixed(whole ? 0 : 2);
    }
  }

  /* ── Dawn's Framing control ──────────────────────────────────────── */
  function scope() {
    return document.querySelector('variant-selects, variant-radios') || document;
  }

  function findSelect(name) {
    var list = scope().querySelectorAll('select');
    for (var i = 0; i < list.length; i++) {
      if ((list[i].name || '').indexOf(name) !== -1) return list[i];
    }
    return null;
  }

  function findRadios(name) {
    return Array.prototype.filter.call(
      scope().querySelectorAll('input[type="radio"]'),
      function (r) { return (r.name || '').indexOf(name) !== -1; }
    );
  }

  function getOptionValue(name) {
    var s = findSelect(name);
    if (s) return s.value;
    var radios = findRadios(name);
    for (var i = 0; i < radios.length; i++) if (radios[i].checked) return radios[i].value;
    return null;
  }

  function getDawnValue() { return getOptionValue(OPTION); }

  /* Every value Dawn offers for the frame option */
  function dawnValues() {
    var s = findSelect(OPTION);
    if (s) return Array.prototype.map.call(s.options, function (o) { return o.value; });
    return findRadios(OPTION).map(function (r) { return r.value; });
  }

  function setDawnValue(value) {
    var s = findSelect(OPTION);
    if (s) {
      if (s.value === value) return;
      var exists = Array.prototype.some.call(s.options, function (o) { return o.value === value; });
      if (!exists) { console.warn('[Alluvion Frames] No Framing value "' + value + '"'); return; }
      s.value = value;
      s.dispatchEvent(new Event('change', { bubbles: true }));
      return;
    }
    var radios = findRadios(OPTION);
    for (var i = 0; i < radios.length; i++) {
      if (radios[i].value === value) {
        if (!radios[i].checked) radios[i].click();
        return;
      }
    }
    console.warn('[Alluvion Frames] No Framing value "' + value + '"');
  }

  function hideDawnControl() {
    var el = findSelect(OPTION) || findRadios(OPTION)[0];
    var wrap = el && el.closest('.product-form__input');
    if (wrap) wrap.classList.add('alv-fp-hidden');
  }

  /* Newer Dawn versions rebuild the variant picker after each change */
  function watchDawn() {
    var vs = document.querySelector('variant-selects, variant-radios');
    if (vs && vs.parentNode && window.MutationObserver) {
      new MutationObserver(hideDawnControl).observe(vs.parentNode, { childList: true });
    }
  }

  /* ── State ────────────────────────────────────────────────────────── */
  function parseValue(v) {
    state.mount = CFG.mount && v.slice(-MOUNT_SUFFIX.length) === MOUNT_SUFFIX;
    state.frame = state.mount ? v.slice(0, -MOUNT_SUFFIX.length) : v;
  }

  function combined() {
    return state.frame + (state.mount ? MOUNT_SUFFIX : '');
  }

  function onAnyChange(e) {
    var el = e.target;
    if (!el || !el.name || (ui.root && ui.root.contains(el))) return;
    if (el.name.indexOf(OPTION) !== -1) { parseValue(el.value); update(); }
    else if (el.name.indexOf('Size') !== -1) { update(); } /* mount price can differ by size */
  }

  function apply() {
    setDawnValue(combined());
    update();
  }

  /* ── UI ───────────────────────────────────────────────────────────── */
  function buildUi() {
    var images = window.ALV_SWATCHES || {};
    var root = document.createElement('div');
    root.className = 'alv-fp';
    root.id = 'alv-frame-picker';

    var html =
      '<p class="form__label alv-fp__legend" id="alv-fp-legend">' + CFG.label + ': <span class="alv-fp__current"></span></p>' +
      '<div class="alv-fp__swatches" role="radiogroup" aria-labelledby="alv-fp-legend">';
    FRAMES.forEach(function (f) {
      html +=
        '<button type="button" class="alv-fp__swatch" role="radio" aria-checked="false" data-frame="' + f.value + '">' +
          '<span class="alv-fp__chip" data-frame-chip="' + f.value + '"></span>' +
          '<span class="alv-fp__name">' + f.label + '</span>' +
        '</button>';
    });
    html += '</div>';
    root.innerHTML = html;

    /* Chip colours / images */
    FRAMES.forEach(function (f) {
      var chip = root.querySelector('[data-frame-chip="' + f.value + '"]');
      chip.style.backgroundColor = f.color;
      if (images[f.value]) chip.style.backgroundImage = 'url("' + images[f.value] + '")';
    });

    root.querySelector('.alv-fp__swatches').addEventListener('click', function (e) {
      var btn = e.target.closest('.alv-fp__swatch');
      if (!btn) return;
      state.frame = btn.getAttribute('data-frame');
      apply();
    });


    /* Place after Dawn's variant picker (outside it, so Dawn's re-renders don't remove it) */
    var vs = document.querySelector('variant-selects, variant-radios');
    var anchor = vs || (findSelect(OPTION) || findRadios(OPTION)[0]).closest('.product-form__input');
    anchor.parentNode.insertBefore(root, anchor.nextSibling);

    ui.root     = root;
    ui.current  = root.querySelector('.alv-fp__current');
    ui.swatches = root.querySelectorAll('.alv-fp__swatch');
    ui.mount    = root.querySelector('#alv-mount');
    ui.hint     = root.querySelector('.alv-fp__hint');
    ui.price    = root.querySelector('.alv-fp__mount-price');
  }

  function update() {
    if (!ui.root) return;
    var label = state.frame;
    Array.prototype.forEach.call(ui.swatches, function (b) {
      var on = b.getAttribute('data-frame') === state.frame;
      b.setAttribute('aria-checked', on ? 'true' : 'false');
      if (on) label = b.querySelector('.alv-fp__name').textContent;
    });
    ui.current.textContent = label;
    if (!CFG.mount) return;
    ui.mount.checked = state.mount;
    ui.hint.textContent = hintText();

    /* Mount price difference at the current size and frame */
    var base      = priceFor(state.frame);
    var withMount = priceFor(state.frame + MOUNT_SUFFIX);
    var diff      = (base !== null && withMount !== null) ? withMount - base : null;
    ui.price.textContent = diff > 0 ? '+' + formatMoney(diff) : '';
  }

  function hintText() {
    return MOUNT_TEXT;
  }

  /* ── Styles ──────────────────────────────────────────────────────── */
  function injectStyles() {
    if (document.getElementById('alv-fp-styles')) return;
    var style = document.createElement('style');
    style.id = 'alv-fp-styles';
    style.textContent = [
      '.alv-fp-hidden,',
      'variant-selects .product-form__input:has(select[name*="' + OPTION + '"]),',
      'variant-selects .product-form__input:has(input[type="radio"][name*="' + OPTION + '"]) { display: none !important; }',
      /* Hide Dawn's own size label (step 2 heading replaces it) but keep it for screen readers */
      '.alv-step { display: flex; align-items: center; gap: 1rem; margin: 0 0 1rem; font-size: 1.5rem; line-height: 1.3; color: rgb(var(--color-foreground)); }',
      '.alv-step__num { flex: 0 0 auto; display: inline-flex; align-items: center; justify-content: center; width: 2.4rem; height: 2.4rem; border-radius: 50%; background: rgb(var(--color-foreground)); color: rgb(var(--color-background)); font-size: 1.2rem; font-weight: 600; line-height: 1; }',
      '.alv-fp { margin: 0 0 2rem; }',
      '.alv-fp__legend { margin: 0 0 1rem; }',
      '.alv-fp__current { color: rgba(var(--color-foreground), .7); }',
      '.alv-fp__swatches { display: grid; grid-template-columns: repeat(5, minmax(0, 1fr)); gap: .8rem; }',
      '.alv-fp__swatch { display: flex; flex-direction: column; align-items: center; gap: .6rem; padding: .6rem .6rem .8rem; border: 1px solid rgba(var(--color-foreground), .15); border-radius: var(--inputs-radius, 4px); background: none; color: inherit; font: inherit; cursor: pointer; transition: border-color .15s, box-shadow .15s; }',
      '.alv-fp__swatch:hover { border-color: rgba(var(--color-foreground), .45); }',
      '.alv-fp__swatch[aria-checked="true"] { border-color: rgb(var(--color-foreground)); box-shadow: 0 0 0 1px rgb(var(--color-foreground)); }',
      '.alv-fp__swatch:focus-visible { outline: 2px solid rgb(var(--color-foreground)); outline-offset: 2px; }',
      '.alv-fp__chip { display: block; width: 100%; aspect-ratio: 1; border-radius: 2px; background-size: cover; background-position: center; box-shadow: inset 0 0 0 1px rgba(0,0,0,.08); }',
      '.alv-fp__name { font-size: 1.15rem; line-height: 1.2; text-align: center; }',
      '.alv-fp__mount { position: relative; display: flex; align-items: center; gap: 1.2rem; margin-top: 1.2rem; padding: 1.2rem 1.4rem; border: 1px solid rgba(var(--color-foreground), .15); border-radius: var(--inputs-radius, 4px); cursor: pointer; }',
      '.alv-fp__mount input { position: absolute; width: 1px; height: 1px; opacity: 0; pointer-events: none; }',
      '.alv-fp__toggle { position: relative; flex: 0 0 auto; width: 4.2rem; height: 2.4rem; border-radius: 2.4rem; background: rgba(var(--color-foreground), .2); transition: background .2s; }',
      '.alv-fp__toggle::after { content: ""; position: absolute; top: .3rem; left: .3rem; width: 1.8rem; height: 1.8rem; border-radius: 50%; background: rgb(var(--color-background)); box-shadow: 0 1px 2px rgba(0,0,0,.2); transition: transform .2s; }',
      '.alv-fp__mount input:checked + .alv-fp__toggle { background: rgb(var(--color-foreground)); }',
      '.alv-fp__mount input:checked + .alv-fp__toggle::after { transform: translateX(1.8rem); }',
      '.alv-fp__mount input:focus-visible + .alv-fp__toggle { outline: 2px solid rgb(var(--color-foreground)); outline-offset: 2px; }',
      '.alv-fp__mount-text { display: flex; flex-direction: column; gap: .2rem; font-size: 1.4rem; line-height: 1.3; }',
      '.alv-fp__hint { font-size: 1.2rem; color: rgba(var(--color-foreground), .65); }',
      '.alv-fp__mount-price { margin-left: auto; padding-left: .8rem; font-size: 1.4rem; white-space: nowrap; color: rgb(var(--color-foreground)); }',
      '@media (prefers-reduced-motion: reduce) { .alv-fp__toggle, .alv-fp__toggle::after { transition: none; } }',
      '@media (max-width: 400px) { .alv-fp__swatches { gap: .5rem; } .alv-fp__name { font-size: 1.05rem; } }'
    ].join('\n');
    document.head.appendChild(style);
  }

})();